module.exports = __webpack_public_path__ + "img/PRNT_04_mono_AE_00000.fe739af4.png";